<div class="u-width-100" *ngFor="let item of values; let i = index">
  <label [for]="item.value" class="checkbox u-margin-0">
    <input
      type="checkbox"
      [name]="item.value"
      class="checkbox__input"
      [id]="item.value"
      (click)="handleOptionClick(item.value)"
      [checked]="isSelected(item.value)"
      [disabled]="isSoleSelection(item.value)"
    />
    <span class="checkbox__indicator"
      ><i class="fa fa-check" aria-hidden="true"></i
    ></span>
    <div class="checkbox__label">
      {{ item.name }}
      <p *ngIf="item.description">{{ item.description }}</p>
    </div>
  </label>
</div>
